import clsx from 'clsx'
import Highcharts, { TooltipFormatterContextObject } from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { useRef } from 'react'
import { ClassName } from 'types/props'

import classes from './index.module.scss'

export { LeverageRatioColumnChart } from './leverage-ratio-column-chart'
export { ProtectionLevelColumnChart } from './protection-level-column-chart'

interface OptionProps {
  categories: string[]
  data: Highcharts.PointOptionsObject[]
  tooltipFormatter: (that: TooltipFormatterContextObject) => string
}

const getOptions = ({ categories, data, tooltipFormatter }: OptionProps): Highcharts.Options => ({
  chart: {
    type: 'column',
    animation: false,
    borderWidth: 0,
    plotBorderWidth: 0,
    plotShadow: false,
    spacing: [10, 0, 0, 0],
    backgroundColor: 'none',
    borderColor: 'none',
    reflow: true
  },
  title: {
    text: ''
  },
  tooltip: {
    enabled: true,
    animation: false,
    backgroundColor: 'var(--White)',
    borderColor: 'var(--White20)',
    borderRadius: 8,
    borderWidth: 2,
    padding: 12,
    shape: 'square',
    shadow: false,
    style: {
      fontSize: '15'
    },
    formatter() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const that = this
      return tooltipFormatter(that)
    },
    useHTML: true
  },
  xAxis: {
    categories,
    crosshair: false,
    startOnTick: true,
    endOnTick: true,
    labels: {
      style: {
        fontSize: '15px',
        color: '#333333'
      },
      y: 40
    }
  },
  yAxis: {
    opposite: true,
    allowDecimals: false,
    labels: {
      style: {
        fontSize: '15px',
        color: '#333333'
      },
      align: 'center',
      x: 24
    }
  },
  plotOptions: {
    column: {
      showInLegend: false,
      groupPadding: 0,
      colorByPoint: true,
      pointPadding: 0,
      borderWidth: 0
    }
  },
  series: [
    {
      name: '',
      type: 'column',
      colors: ['#EFD0D3', '#E4A6AA', '#D87C82', '#D0555B', '#DB1E2F'],
      states: {
        hover: {
          color: '#be0028'
        }
      },
      data
    }
  ]
})

type Props = OptionProps & ClassName

export const ColumnChart = ({ categories, className, data, tooltipFormatter }: Props) => {
  const ref = useRef()
  const options = getOptions({ data, categories, tooltipFormatter })
  return (
    <div className={clsx(classes.root, className)}>
      <HighchartsReact ref={ref} highcharts={Highcharts} options={options} />
    </div>
  )
}
